var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ height: "77", viewBox: "0 0 2001 77", width: "2001", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "mask",
      { id: "a", fill: "#fff" },
      React.createElement("path", { d: "M0 0h2001v77H0z", fillRule: "evenodd" })
    ),
    React.createElement("path", { d: "M2000-804l.024 450.751C2252.224-307.619 2408-244.822 2408-175.5 2408-36.048 1777.617 77 1000 77S-408-36.048-408-175.5c0-69.322 155.776-132.12 407.977-177.749L0-804z", fill: "#36312c", fillRule: "evenodd", mask: "url(#a)" })
  );
});


// WEBPACK FOOTER //
// ./components/svg/bg/rounded-background.svg